import { TiptapDisplay, type TiptapVariantProps } from "@msuite/ui/libs/tiptap";
import { Popover } from "@msuite/ui/popover";
import type { ClassNameProps } from "@msuite/ui/types";
import { cn } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";
import type { Nullable } from "@msuite/utils/types";
import React from "react";
import { useMentionOptions } from "@/hooks/use-mention-options";

/** Props Interface */
interface NoteTextProps extends ClassNameProps, TiptapVariantProps {
	note: Nullable<string>;
	withPopover?: boolean;
}

export function NoteText({ note, className, withPopover = true, lineClamp }: NoteTextProps) {
	/** Guard */
	if (!note) return guardString(null);

	const mentionOptions = useMentionOptions();

	/** Render */
	return (
		<React.Fragment>
			<Popover
				trigger="hover"
				isDisabled={!withPopover}
				render={() => (
					<div className="w-100 max-h-100 overflow-y-auto">
						<TiptapDisplay
							json={note}
							{...mentionOptions}
						/>
					</div>
				)}
			>
				<div className={cn("tiptap", className)}>
					<TiptapDisplay
						json={note}
						lineClamp={lineClamp}
						{...mentionOptions}
					/>
				</div>
			</Popover>
		</React.Fragment>
	);
}
